// test1647
(1647 && 0);
